import SignInSide from '../components/Auth/SignInSide';

const LoginPage = () => {
  return <SignInSide />;
};

export default LoginPage;
